<template>
    <div>
        <el-tabs :tab-position="'top'" type="" style="margin-top: 0px">
            <el-tab-pane :label="$t('getapi[7100]')">
                <el-card class="box-card">
                    <div style="display: flex;background: white">
                        <div style="width: 50%;text-align: left;display: flex">
                            <el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                            <el-button type="primary" size="mini" :disabled="!btn.Add" @click="showitems('0')">{{$t('getapi[438]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="deleteAll">{{$t('getapi[4411]')}}</el-button>

                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadurl"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :on-change="handleChange"
                                    :on-success="handleSuccess"
                                    :on-error="handleError"
                                    :file-list="fileList"
                                    :limit="1"
                                    accept=".xlsx"
                                    style="margin-left: 8px"
                            >
                                <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[4410]')}}
                                </el-button>
                            </el-upload>
                        </div>
                        <div style="width: 50%;text-align: right">
                            <el-button type="primary" size="mini" @click="check">{{$t('getapi[4413]')}}</el-button>
                            <el-button type="primary" size="mini" @click="update">{{$t('getapi[4414]')}}</el-button>
                            <!--<el-button type="primary" size="mini">关闭</el-button>-->
                        </div>
                    </div>
                </el-card>
                <div id="xpane-0">
                    <vxe-table :data="datajson"
                           show-overflow
                           ref='CloseSoTable'
                           size="mini" 
                           :loading="loading" 
                           :height="tableHeight" 
                           stripe border resizable
                           :header-cell-style="$limits.headerClass">
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="State" :title="$t('getapi[552]')" width="100px" sortable>
                        <template slot-scope="scope">
                            <span v-if="scope.row.State == '未校验'"><font color="green">{{scope.row.State}}</font></span>
                            <span v-if="scope.row.State == '可关闭'"><font color="green">{{scope.row.State}}</font></span>
                            <span v-if="scope.row.State == '不可关闭'"><font color="red">{{scope.row.State}}</font></span>
                            <span v-if="scope.row.State == 'SO已关闭'"><font
                                    color="green">{{scope.row.State}}</font></span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="so_code" :title="$t('getapi[4168]')" width="200" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="remark" :title="$t('getapi[1633]')" width="200" sortable>
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.remark"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"
                                      width="200px" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')"
                                      width="90px" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[876]')"
                                      width="100px" sortable></vxe-table-column>

                    <vxe-table-column show-footer-overflow field="s_ProIn" :title="$t('getapi[2153]')"
                                      width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_ProIn == true ? 'red':'green'}">{{scope.row.s_ProIn == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_ProRepair" :title="$t('getapi[4402]')"
                                      width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_ProRepair == true ? 'red':'green'}">{{scope.row.s_ProRepair == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_Collectout" :title="$t('getapi[4403]')"
                                      width="110px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_Collectout == true ? 'red':'green'}">{{scope.row.s_Collectout == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_CollBoardout" :title="$t('getapi[4404]')"
                                      width="120px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_CollBoardout == true ? 'red':'green'}">{{scope.row.s_CollBoardout == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_Proout" :title="$t('getapi[4405]')" width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_Proout == true ? 'red':'green'}">{{scope.row.s_Proout == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_Wipout" :title="$t('getapi[7101]')" width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_Wipout == true ? 'red':'green'}">{{scope.row.s_Wipout == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_ProMove" :title="$t('getapi[4406]')" width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_ProMove == true ? 'red':'green'}">{{scope.row.s_ProMove == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_wipMove" :title="$t('getapi[7102]')" width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_wipMove == true ? 'red':'green'}">{{scope.row.s_wipMove == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="s_ProcOrder" :title="$t('getapi[453]')" width="100px" sortable>
                        <template slot-scope="scope">
                            <span :style="{'color': scope.row.s_ProcOrder == true ? 'red':'green'}">{{scope.row.s_ProcOrder == true ? $t('getapi[489]'):$t('getapi[490]')}}</span>
                        </template>
                    </vxe-table-column>

                    <vxe-table-column show-footer-overflow fixed="right" :title="$t('getapi[6048]')" width="80">
                        <template slot-scope="scope">
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[40]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="delline(scope)"
                            >
                                <el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                </div>
                <el-row>
                    <el-col :span="24">
                        <div style="text-align: left;line-height: 30px;color: blue;font-size:larger">{{$t('getapi[467]')}}<strong>{{
                            datajson.length }} </strong>{{$t('getapi[4426]')}}
                        </div>
                    </el-col>
                </el-row>

            </el-tab-pane>


            <el-tab-pane :label="$t('getapi[4729]')"><!-- 计划完工日期 -->
                <el-card class="box-card">
                    <div style="display: flex;background: white">
                        <div style="width: 50%;text-align: left;display: flex">
                            <el-button type="primary" size="mini" @click="download2">{{$t('getapi[6506]')}}</el-button>
                            <el-button type="primary" size="mini" @click="showitems('1')">{{$t('getapi[438]')}}</el-button>
                            <el-button type="primary" size="mini" @click="deleteAll2()">{{$t('getapi[437]')}}</el-button>

                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadurlplan"
                                    :on-preview="handlePreview"
                                    :on-remove="handleRemove"
                                    :on-change="handleChange"
                                    :on-success="handleSuccess"
                                    :on-error="handleError"
                                    :file-list="fileList"
                                    :limit="1"
                                    :auto-resize="true"
                                    accept=".xlsx"
                                    style="margin-left: 8px"
                            >
                                <el-button slot="trigger" size="mini" type="primary" :disabled="!btn.Import">{{$t('getapi[436]')}}
                                </el-button>
                            </el-upload>
                        </div>
                        <div style="width: 50%;text-align: right">
                            <el-button type="primary" size="mini" @click="update2">{{$t('getapi[1716]')}}</el-button>
                        </div>
                    </div>
                </el-card>
                <!-- 表格 -->
                <vxe-table :data="datajsonliu" round
                           show-overflow
                           empty-text=""
                           ref='PlanSoTable'
                           size="mini"
                           :loading="loading"
                           :height="tableHeight - 40"
                           stripe border resizable
                           :header-cell-style="$limits.headerClass">
                    <vxe-table-column type="checkbox" align="center" width="60"></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="Exec_Flag" :title="$t('getapi[552]')" width="100px" sortable>
                        <template scope="scope">
                            <span v-if="scope.row.Exec_Flag == '-1'"><font color="red" sortable>{{$t('getapi[4453]')}}</font></span>
                            <span v-if="scope.row.Exec_Flag == '0'"><font color="green">{{$t('getapi[4454]')}}</font></span>
                            <span v-if="scope.row.Exec_Flag == '1'"><font color="green">{{$t('getapi[4454]')}}</font></span>
                            <span v-if="scope.row.Exec_Flag == '2'"><font color="red">{{$t('getapi[4455]')}}</font></span>
                            <span v-if="scope.row.Exec_Flag == '3'"><font color="green">{{$t('getapi[8628]')}}</font></span>
                            <span v-if="scope.row.Exec_Flag == '4'"><font color="yellow">{{$t('getapi[3128]')}}</font></span>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow field="so_code" :title="$t('getapi[4168]')" width="200" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_code" :title="$t('getapi[112]')"
                                      width="200px" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="part_version" :title="$t('getapi[149]')"
                                      width="100px" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="item_code" :title="$t('getapi[876]')"
                                      width="100px" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="old_date" :title="$t('getapi[4415]')"
                                      width="150px" sortable></vxe-table-column>
                    <vxe-table-column show-footer-overflow field="new_date" :title="$t('getapi[4416]')" width="150px" sortable>
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.new_date"></el-input>
                        </template>
                    </vxe-table-column>
                    <vxe-table-column show-footer-overflow fixed="right" :title="$t('getapi[6048]')" width="80" sortable>
                        <template slot-scope="scope">
                            <el-popconfirm
                                    :confirmButtonText="$t('getapi[40]')"
                                    :cancelButtonText="$t('getapi[6]')"
                                    icon="el-icon-info"
                                    iconColor="red"
                                    :title="$t('getapi[637]')"
                                    @onConfirm="dellineliu(scope)"
                            >
                                <el-button slot="reference" type="text" size="mini">{{ $t('getapi[40]') }}</el-button>
                            </el-popconfirm>
                        </template>
                    </vxe-table-column>
                </vxe-table>
                <el-row>
                    <el-col :span="24">
                        <div style="text-align: left;line-height: 30px;color: blue;font-size:larger">{{$t('getapi[467]')}}<strong>{{
                            datajsonliu.length }} </strong>{{$t('getapi[4426]')}}
                            <span><font color="red">{{$t('getapi[7103]')}}</font></span>
                        </div>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>

        <!-- SO单据号选择 -->
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Pro/SO/GetSOPopupDataList'" @callback="getitem" ref="input"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '2_sobatch',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight1
            }
        },
        data() {
            return {
                fileList: [],
                itevisible: false,
                tabIndex: '0',
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                datajsonremark: [],
                datajsonliu: [],
                loading: false, // 主表加载状态
                uploadurl: '',
                uploadurlplan: '',
                uploadurlremark: '',
                uploadurlliu: '',
                drolist: [],
                drolistliu: [],
                drosele: 0,
                droseleliu: 0,
                total1: 0,
                btn: {
                    //添加
                    Add: true,
                    //移除
                    Remove: false,
                    //导入
                    Import: true
                },
                scrollTop:0,
                scrollTop1:0,
            };
        },
        created() {
            setTimeout(() => {
                this.datajsonliu = [];
                this.datajson = [];
            }, 1000)
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Pro/SO/CloseSoImportUpFile?token=' + token;
            that.uploadurlplan = Common.Url + '/Pro/SO/PlanSoImportUpFile?token=' + token;
            this.getDropList();
            this.getDropLists();
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            console.log('mounted');
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.CloseSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.PlanSoTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.CloseSoTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.PlanSoTable.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            btnauthority() {
                let that = this;
                //工时
                that.btn.Manhour = false;
                //备注
                that.btn.Notes = false;

                if (that.$limits.authority('plv3', 38, 1) > 0) {
                    //工时
                    that.btn.Manhour = true;
                    //备注
                    that.btn.Notes = true;
                }

            },
            // SO选择弹框
            showitems(type) {
                let that = this;
                that.itevisible = true;
                let param = {
                    Code: type
                }
                that.tabIndex = type;
                this.$refs.input.clearInput(this.itevisible, param);
            },
            getitem(data) {
                let that = this;
                console.log(data)
                if (that.tabIndex == '0') {
                    if (data.length > 0) {
                        //排重
                        for (let i = 0; i < data.length; i++) {
                            let hasAdd = false;
                            for (let j = 0; j < that.datajson.length; j++) {
                                if (data[i].so_code == that.datajson[j].so_code) {
                                    hasAdd = true;
                                    break;
                                }
                            }
                            if (!hasAdd) {
                                let param = data[i];
                                param.State = '未校验';
                                that.datajson.push(param);
                            }
                        }
                    }
                } else {
                    if (data.length > 0) {
                        //排重
                        for (let i = 0; i < data.length; i++) {
                            let hasAdd = false;
                            for (let j = 0; j < that.datajsonliu.length; j++) {
                                if (data[i].so_code == that.datajsonliu[j].so_code) {
                                    hasAdd = true;
                                    break;
                                }
                            }
                            if (!hasAdd) {
                                let param = data[i];
                                //param.old_date = data[i].plan_finish_date;
                                param.old_date = that.$limits.getDateType(data[i].plan_finish_date);
                                delete data[i]["plan_finish_date"];
                                //param.State='可修改';
                                param.Exec_Flag = '0';
                                that.datajsonliu.push(param);
                            }
                        }
                    }
                }
            },
            deleteAll() {
                let that = this;
                let selectRecords = this.$refs.CloseSoTable.getCheckboxRecords();
                for (let i = selectRecords.length - 1; i >= 0; i--) {
                    let line = this.$refs.CloseSoTable.getRowIndex(selectRecords[i]);
                    that.datajson.splice(line, 1);
                }
            },
            deleteAll2() {
                let that = this;
                let selectRecords = this.$refs.PlanSoTable.getCheckboxRecords();
                for (let i = selectRecords.length - 1; i >= 0; i--) {
                    let line = this.$refs.PlanSoTable.getRowIndex(selectRecords[i]);
                    that.datajsonliu.splice(line, 1);
                }
            },
            //校验1
            check() {
                let that = this;
                if (that.datajson.length <= 0) {
                    this.$message.warning(that.$t('getapi[4435]'));//"请首先添加要执行关闭的SO工单号。"
                    return;
                }
                let count = 0;
                for (let i = 0; i < that.datajson.length; i++) {

                    if (that.datajson[i].State == null || (that.datajson[i].State != "未校验" && that.datajson[i].State != "可关闭" && that.datajson[i].State != "不可关闭")) {
                        count = 1;
                        break;
                    }
                }
                if (count > 0) {
                    this.$message.warning(that.$t('getapi[4438]'));//列表中有不存在或非开工状态的SO单，请删除或修改。
                    return;
                }

                let parm = []
                for (let i = 0; i < that.datajson.length; i++) {
                    parm = [...parm, {
                        so_code: that.datajson[i].so_code,
                        part_code: that.datajson[i].part_code,
                        part_version: that.datajson[i].part_version,
                        State: that.datajson[i].State,
                        item_code: that.datajson[i].item_code,
                        remark: that.datajson[i].remark,
                    }]
                }
                that.$http.urlpost('/Pro/SO/CloseSoItemCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.datajson = res.DataContent;
                    }
                });
            },
            //执行关闭
            update() {
                let that = this;
                if (that.datajson.length <= 0) {
                    this.$message.warning(that.$t('getapi[4435]'));//"请首先添加要执行关闭的SO工单号。"
                    return;
                }
                for (let i = 0; i < that.datajson.length; i++) {
                    if (!that.$limits.fnIsEmpty(that.datajson[i].State) && that.datajson[i].State != "可关闭") {
                        this.$message.warning(that.$t('getapi[4439]'));//"SO列表中有不可关闭的SO单，请删除相关单据后重新校验。"
                        return;
                    }

                    if (that.$limits.fnIsEmpty(that.datajson[i].remark)) {
                        this.$message.warning(that.$t('getapi[4440]'));//必须填写关闭原因！
                        return;
                    }
                }
                const confirmText = ['1、执行关闭将强制关闭列表中选择的所有SO单，关闭后工单数据将无法恢复！', '2、关闭可能造成其他生产相关单据产生错误，执行前请详细相关生产单据状态。'
                    , '3、SO强制关闭后，将清空该SO物料在所有车间货位（除半成品区外）中的数量。', '执行强制关闭选择【确定】，否则选择【取消】。']
                const newDatas = []
                const h = this.$createElement;
                for (const i in confirmText) {
                    newDatas.push(h('p', null, confirmText[i]))
                }

                this.$confirm(
                    h('div', null, newDatas), that.$t('getapi[241]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning',
                    })
                    .then(() => {
                        that.loading = true;
                        that.$http.urlpost('/Pro/SO/CloseSoExecute', that.datajson, function (res) {
                            that.loading = false;
                            if (res.Success == 1) {
                                that.datajson = res.DataContent;
                                that.$message.success(that.$t('getapi[8709]'));//'SO关闭成功！'
                            }
                        });

                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });

            },
            update2() {
                let that = this;

                if (that.datajsonliu.length > 0) {
                    let parm = {
                        Lists: that.datajsonliu,
                        LangType:that.$processdata.getLang()
                    };
                    that.loading = true;
                    that.$http.urlpost('/Pro/SO/PlanSoExecute',parm, function (res) {
                        that.loading = false;
                        if (res.Success == 1) {
                            that.datajsonliu = res.DataContent;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                        else{
                            that.datajsonliu = res.DataContent;
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }

                    });
                }

            },
            download() {
                let param = {
                    url: '/Pro/SO/CloseSOTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            download2() {
                let param = {
                    url: '/Pro/SO/ModifySODateTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            //删除行
            delline(e) {
                console.log(e);
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajson.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            dellines(e) {
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajsonremark.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            dellineliu(e) {
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajsonliu.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },

            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].Exclusively_Id + ',';
                }
                console.log(that.selectIDData);
            },
            //工艺工时更新字段下拉框
            getDropList() {
                let that = this;
                that.$http.urlpost('Eng/Routings/RWHoursDropList', {}, res => {
                    console.log(res);
                    if (res.Success == 1) {
                        that.drolist = res.DataContent;
                        that.total1 = res.DataContent.length;
                    }
                });
            },
            //流转下拉
            getDropLists() {
                let that = this;
                that.$http.urlpost('Eng/Routings/RoutMoveDropList', {}, res => {
                    console.log(res);
                    if (res.Success == 1) {
                        that.drolistliu = res.DataContent;
                    }
                });
            },

            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        if (file.response.DataContent.length > 0) {
                            var count = Object.keys(file.response.DataContent[0]).length;
                            if (count > 6) {
                                that.datajsonliu = file.response.DataContent;
                            } else {
                                that.datajson = file.response.DataContent;
                            }
                        } else {
                            that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                        }
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    if (res.DataContent.length > 0) {
                        var count = Object.keys(res.DataContent[0]).length;//字段个数
                        if (count > 6) {
                            that.datajsonliu = res.DataContent;
                            for (let i = 0; i < that.datajsonliu.length; i++) {
                                that.datajsonliu[i].new_date = that.$limits.getDateType(that.datajsonliu[i].new_date)
                                that.datajsonliu[i].old_date = that.$limits.getDateType(that.datajsonliu[i].old_date)
                            }
                        } else {
                            that.datajson = res.DataContent;
                        }
                    } else {
                        that.$message.warning(that.$t('getapi[8711]'));//Excel中无数据！
                    }

                }
                that.fileList = [];
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleChangeremark(file, fileList) {
                let that = this;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        that.datajsonremark = file.response.DataContent;
                    }
                }
            },
            handleSuccessremark(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajsonremark = res.DataContent;
                }
            },
            handleErrorremark(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleChangeliu(file, fileList) {
                let that = this;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(that.$processdata.explainCallbackMsg(file.response.Msg));
                    } else {
                        that.datajsonliu = file.response.DataContent;
                    }
                }
            },
            handleSuccessliu(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    that.datajsonliu = res.DataContent;
                }
                that.fileList = [];

            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview" + file);
            },
            // 保存数据
            okbtn() {
                let that = this;
                that.loading = true;
                let parm = {
                    SaveType: that.drosele,
                    LangType: that.$processdata.getLang(),
                    List: []
                };
                parm.List = that.datajson;
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/Routings/RWHoursSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[818]'));
                    }
                    that.loading = false;
                });
            },
            // 保存备注数据
            okbtns() {
                let that = this;
                that.loading = true;
                let parm = that.datajsonremark;
                console.log(JSON.stringify(parm));
                that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[818]'));
                    }
                    that.loading = false;
                });
            },
            // 保存流转方向数据
            okbtnliu() {
                let that = this;
                if (that.droseleliu == 4) {
                    that.loading = true;
                    let parm = that.datajsonliu;
                    console.log(JSON.stringify(parm));
                    that.$http.urlpost('Eng/Routings/RoutRemarkSave', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[818]'));
                        }
                        that.loading = false;
                    });
                } else if (that.droseleliu == 3) {
                    that.loading = true;
                    let parm = {
                        SaveType: that.droseleliu,
                        List: []
                    };
                    parm.List = that.datajsonliu;
                    console.log(JSON.stringify(parm));
                    that.$http.urlpost('Eng/Routings/RoutMoveSave', parm, function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$t('getapi[818]'));
                        }
                        that.loading = false;
                    });
                } else {

                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
</style>
<style>
    .el-message-box {
        width: 600px;
    }
</style>
